import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Col, Row } from 'antd';
import { Icon } from 'ui';

const StyledCard = styled.div`
  box-shadow: 0 0 10px 0 #A9BEC8 !important;
  border: 1px solid #A3A3A3;
  background: #fff;
  border-radius: 5px;
  padding: 5px;
  font-size: 16px;
  margin-bottom: 20px;
`;

const Title = styled.p`
  font-size: 24px;
  font-weight: bold;
`;

const CardHeader = styled(Row)`
  display: flex;
  align-items: center;
  height: 40px;
  margin-bottom: 5px;
`;

const CardContent = styled(Row)`
  margin: 10px;
  margin-top: 0px;
  border-top: 1px solid #DCE4EA;
  padding-top: 8px;
`;

const CardCol = styled(Col)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Footer = styled(Row)`
  margin: 10px;
`;

const FooterCol = styled(Col)`
  display: flex;
  justify-content: ${p => p.footerActionCount === 1 ? 'flex-end' : 'space-evenly'};
`;

const CardIconContainer = styled.div`
  background-color: ${p => p.cardIconColor};
  width: 26px;
  height: 26px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CardIcon = styled(Icon)`
  font-size: 16px;
  color: white;
`;


const InfoCard = ({
  cardIconType,
  cardIconColor,
  children,
  title,
  headerActionComponent = null,
  renderFooter = null,
  footerActionCount = 0,
}) =>
  <StyledCard>
    <CardHeader>
      <CardCol span={2}>
        <CardIconContainer cardIconColor={cardIconColor}>
          <CardIcon type={cardIconType} />
        </CardIconContainer>
      </CardCol>
      <Col span={20}>
        <Title>
          {title}
        </Title>
      </Col>
      <CardCol span={2}>
        {headerActionComponent}
      </CardCol>
    </CardHeader>
    <CardContent>
      {children}
    </CardContent>
    {footerActionCount > 0 ?
      <Footer>
        <FooterCol span={24} footerActionCount={footerActionCount}>
          {renderFooter()}
        </FooterCol>
      </Footer> :
      null
    }
  </StyledCard>;
InfoCard.propTypes = {
  cardIconType: PropTypes.string,
  cardIconColor: PropTypes.string,
  children: PropTypes.object,
  title: PropTypes.string,
  headerActionComponent: PropTypes.object,
  renderFooter: PropTypes.func,
  footerActionCount: PropTypes.number,
};

export default InfoCard;
